import React from 'react';
import styled from "styled-components";
import {UserContext} from "@providers/user";
import Avatar from "@atoms/avatar";
import ButtonBase from "@atoms/button.base";
import ConvertPixelToRem from "@helpers/convert.rem";
import Icon from "@atoms/icon";
import {isEmpty} from "@helpers/helpers";
import Stars from "@atoms/stars";
import {checkPropertyIsAssignedAndOwner, getContactItems} from "../helpers/property_helpers";
import PhoneIcon from '@icons/phone.svg';
import VerifiedBadgeIcon from '@icons/verified-badge.svg';

function CardContact({isBadeSaba, property, categories, setContactInfo}) {
    const {contact_info, request_contact} = property;
    const showRequestForm = (request_contact || isBadeSaba);
    const {avatarPath, profileUrl, avatarType, realtorName, agencyName} = getContactItems(property, isBadeSaba);
    const assignedAndIsOwner = checkPropertyIsAssignedAndOwner(property);

    const userContext = React.useContext(UserContext);
    const authUser = (userContext.check && !isEmpty(userContext.user)) ? userContext.user : null;
    const isMyProperty = (!isEmpty(authUser) && authUser.id === property.user_id && categories !== 'search');

    const handleClickOnContactButton = () => {
        if (!property.archived) {
            setContactInfo({
                show: true,
                property_id: property.id,
                city_id: property.city_id,
                district_id: property.district_id,
                realtor_id: null,
                agency_id: null,
                isAssignedProperty: (assignedAndIsOwner && !isMyProperty),
                isOnList: true,
                exists_in_kanban: (showRequestForm && !isMyProperty),
                isBadeSaba: isBadeSaba,
            })
        }
    };

    return (
        <Card className={"position-relative d-none d-lg-flex flex-column " + (property.archived ? 'is-archived' : '')}>
            <div className="d-flex mt-8">
                {
                    (!property.archived && !isEmpty(profileUrl) && !showRequestForm) ?
                        <a href={profileUrl}>
                            <Avatar size="72" src={avatarPath} type={avatarType} alt={(!isEmpty(realtorName)) ? realtorName : (!isEmpty(agencyName) ? agencyName : property.landlord_name)}/>
                        </a>
                        :
                        <Avatar size="72" src={avatarPath} type={avatarType}/>
                }

                <Info className="mr-16 d-flex justify-content-center flex-column">
                    {
                        (showRequestForm && !isMyProperty) ?
                            <h4 className="d-block h4">کارشناس فروش</h4>
                            :
                            (
                                (assignedAndIsOwner && !isMyProperty) ?
                                    <React.Fragment>
                                        <h4 className="d-block h4">مشاورین این ملک</h4>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        {
                                            (!isEmpty(realtorName)) ?
                                                (
                                                    <React.Fragment>
                                                        {
                                                            (!isEmpty(profileUrl)) ?
                                                                <a href={profileUrl} className="d-block h4" title={realtorName}>{realtorName}</a>
                                                                :
                                                                <h4 className="d-block h4" title={realtorName}>{realtorName}</h4>
                                                        }

                                                        <div className="d-flex align-items-center">
                                                            <AgencyName className="d-block" title={agencyName}>
                                                                {agencyName}
                                                            </AgencyName>

                                                            {
                                                                (!isEmpty(contact_info) && contact_info.agency_authenticated) ?
                                                                    <Icon width={16} height={16} className="mr-4"><VerifiedBadgeIcon/></Icon>
                                                                    : ''
                                                            }
                                                        </div>
                                                    </React.Fragment>
                                                )
                                                :

                                                <React.Fragment>
                                                    {
                                                        (!isEmpty(profileUrl)) ?
                                                            <a href={profileUrl} className="no-text-ellipsis h4" title={agencyName}>
                                                                {agencyName}

                                                                {
                                                                    (!isEmpty(contact_info) && contact_info.agency_authenticated) ?
                                                                        <Icon width={16} height={16} className="mr-4"><VerifiedBadgeIcon/></Icon>
                                                                        : ''
                                                                }
                                                            </a>
                                                            :
                                                            <h4 className="d-block h4 no-text-ellipsis" title={agencyName}>
                                                                {agencyName}

                                                                {
                                                                    (!isEmpty(contact_info) && contact_info.agency_authenticated) ?
                                                                        <Icon width={16} height={16} className="mr-4"><VerifiedBadgeIcon/></Icon>
                                                                        : ''
                                                                }
                                                            </h4>
                                                    }
                                                </React.Fragment>
                                        }
                                    </React.Fragment>
                            )
                    }

                    {
                        (!property.archived && !showRequestForm && isEmpty(contact_info.agency_id) && !isEmpty(contact_info.realtor_id) && !isEmpty(contact_info.stars) && contact_info.stars_count > 0) ?
                            <div className="d-flex align-items-center mt-4">
                                <StarsCard>
                                    <Stars rate={contact_info.stars}/>
                                </StarsCard>

                                <Rate className="mr-8">{contact_info.stars_count} نفر</Rate>
                            </div>
                            :
                            ''
                    }

                </Info>
            </div>

            <ContactButton onClick={handleClickOnContactButton} variant="outline" size="sm" block color="secondary">
                <Icon className="ml-8">
                    <PhoneIcon/>
                </Icon>
                اطلاعات تماس
            </ContactButton>
        </Card>
    )
}

export default React.memo(CardContact);

// styles
const Card = styled.div`
    width: 260px;
    padding: 24px 24px 8px 0;
    border-right: 1px solid ${props => props.theme.gray200};
    
    &.is-archived {
        filter: blur(3px);
        -webkit-filter: blur(3px); /* Safari 6.0 - 9.0 */
        
        &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
        }
    }
`;

const Info = styled.div`
    width: 148px;
    * {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    
    .no-text-ellipsis,.no-text-ellipsis * {
        text-overflow: inherit;
        white-space: inherit;
        overflow: inherit;
        
        .icons {
            position: relative;
            top: 3px;
        }
    }
`;

const StarsCard = styled.div`
    display: inherit;
    
    .icons {
        margin-right: 3px;
        width: 14px;
        
        &:first-child {
            margin-right: 0;
        }
    }
`;

const Rate = styled.span`
    font-size: ${ConvertPixelToRem(12)};
    font-weight: normal;
    line-height: 1.58;
    color: ${props => props.theme.black};
`;

const AgencyName = styled.span`
    font-size: ${ConvertPixelToRem(14)};
    line-height: 1.93;
`;

export const ContactButton = styled(ButtonBase)`
    margin-top: auto;
    
    .icons {
        width: 16px;
        svg {
          path {
            stroke-width: 1.3px;
            stroke: ${props => props.theme.secondary};
          }
        }
    }
`;